import { compose, head, propOr } from 'ramda'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Title } from '../../../../../../packages/kiti/components/presentation/Text'
import { hasValue } from '../../../../../../utils/helpers/value'
import { useChecklistForm, useChecklistFormActions, useSelectedQuestion } from '../../../_form/ChecklistFormHandler'
import Button from '../../../../../../components/actions/Button'
import ConditionInput from '../../../../../../containers/dynamic/conditions/ConditionInput'
import LineSeparator from '../../../../../../packages/kiti/components/helpers/LineSeparator'
import Modal from '../../../../../../components/structure/Modal'
import Separator from '../../../../../../packages/kiti/components/helpers/Separator'
import ToRight from '../../../../../../packages/kiti/components/helpers/ToRight'

const ConditionsModal = () => {
  const { t } = useTranslation('editChecklist')
  const selectedQuestion = useSelectedQuestion()
  const { selectedConditionsIndex } = useChecklistForm()
  const { addChildConditionsToSelectedQuestion, editChildConditionToSelectedQuestion, closeConditionsModal } =
    useChecklistFormActions()

  const selectedCondition = compose(
    head,
    propOr([], selectedConditionsIndex),
    propOr([], 'childDisplayConditions')
  )(selectedQuestion)

  const [value, setValue] = React.useState(selectedCondition)

  const handleSubmit = () => {
    if (!hasValue(value?.value)) return false
    if (value?.value === undefined) return false
    if (selectedCondition) {
      editChildConditionToSelectedQuestion([value])
    } else {
      addChildConditionsToSelectedQuestion([[value]])
    }
    closeConditionsModal()
  }

  return (
    <>
      <Title size="h6">{t('ifAnswerIs')}</Title>
      <LineSeparator />

      <Separator weight={6} />
      <ConditionInput
        value={value}
        type={selectedQuestion.questionType?.name}
        onChange={setValue}
        field="value"
        options={selectedQuestion.options}
      />
      <Separator weight={6} />

      <ToRight>
        <Button disabled={!hasValue(value?.value)} onClick={handleSubmit}>
          {!selectedCondition ? t('addLogic') : t('updateLogic')}
        </Button>
      </ToRight>
    </>
  )
}

const Wrapper = () => {
  const { conditionsModalOpen } = useChecklistForm()
  const { closeConditionsModal } = useChecklistFormActions()

  return (
    <Modal open={conditionsModalOpen} onClose={closeConditionsModal} width="28rem">
      <ConditionsModal />
    </Modal>
  )
}

export default Wrapper
